

export enum EQuestionType {
  group = "group",
  question = "question",
}
